import type { GridRowGroupingModel } from "@mui/x-data-grid-premium";

import type { GroupingField } from "../../../../../../../../api/types/svTypes.ts";

export const getGroupings = (model: GridRowGroupingModel, groupingFields: GroupingField[]) => {
  const groupsToDelete = groupingFields.filter((gf) => !model.find((m) => m === gf.id));
  const groupIdsToAdd = model.filter((m) => !groupingFields.find((gf) => gf.id === m));

  return { groupsToDelete, groupIdsToAdd };
};
